import { render, staticRenderFns } from "./ConfigSentView.vue?vue&type=template&id=2a85ea7f&"
import script from "./ConfigSentView.vue?vue&type=script&lang=ts&"
export * from "./ConfigSentView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports